import React from 'react';
import { Tab as Component } from '@vfuk/core-tabs';
const Tab = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Tab;
